import React, { useState } from 'react'
import RichTextInput from 'ra-input-rich-text'
import { useField } from 'react-final-form'
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import CodeIcon from '@material-ui/icons/Code'

const RichTextInputWithHtmlPreview = ({ source, label, ...rest }) => {
    const [open, setOpen] = useState(false)
    const { input } = useField(source)

    return (
        <div style={{ width: '100%' }}>
            <RichTextInput source={source} label={label} {...rest} />
            <Button
                size="small"
                startIcon={<CodeIcon />}
                onClick={() => setOpen(true)}
                style={{ marginTop: -8, marginBottom: 8 }}
            >
                Visualizar HTML
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>HTML - {label}</DialogTitle>
                <DialogContent>
                    <pre
                        style={{
                            background: '#f5f5f5',
                            padding: 16,
                            borderRadius: 4,
                            overflow: 'auto',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontSize: 13,
                            maxHeight: '60vh',
                        }}
                    >
                        {input.value || ''}
                    </pre>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default RichTextInputWithHtmlPreview
